import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Path: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m490 660h-213.33c-86.39 0-156.67-70.28-156.67-156.67s70.28-156.67 156.67-156.67h255c54.22 0 98.33-44.11 98.33-98.33s-44.11-98.33-98.33-98.33h-276.67c-8.28 0-15-6.72-15-15s6.72-15 15-15h276.67c70.76 0 128.33 57.57 128.33 128.33s-57.57 128.33-128.33 128.33h-255c-69.84 0-126.67 56.82-126.67 126.67s56.82 126.67 126.67 126.67h213.33c8.28 0 15 6.72 15 15s-6.72 15-15 15z' />
    <circle cx='615' cy='645' r='45' />
    <path d='m120 150h160s0-30 0-30h-130c-16.57 0-30 13.43-30 30z' />
    <path d='m540 660h-160s0-30 0-30h130c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

Path.displayName = 'Path';

export default Path;
